// extracted by mini-css-extract-plugin
module.exports = {"HeroVideo":"styles_HeroVideo__0Ce6m","video":"styles_video__zEjLK"};